import { render, staticRenderFns } from "./ProjectChangesModal.vue?vue&type=template&id=5087564e&scoped=true&"
import script from "./ProjectChangesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChangesModal.vue?vue&type=style&index=0&id=5087564e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087564e",
  null
  
)

export default component.exports